import React from "react";
import { Chip, Stack } from "@mui/material";
import PayerChip from "./payerChip";

const SourceBadge = ({ item }) => {
  if (item.type === "AI") {
    return (
      <Chip
        label="AI & Scribe"
        size="small"
        sx={{
          height: 30,
          borderRadius: "999px",
          background: "#dff8f6",
          border: "1px solid #80e6dc",
          color: "#146c94",
          fontWeight: 700,
          fontSize: 12,
          "& .MuiChip-label": {
            px: 1.5,
          },
        }}
      />
    );
  }

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {item.payers.map((payer) => (
        <PayerChip key={`${item.id}-${payer}`} payer={payer} small />
      ))}
    </Stack>
  );
};

export default SourceBadge;
